//-- Copyright (c) 2021 TMT Insights Group, LLC
import { TaskConfig } from '@/__configs/config_types';

const taskConfig: TaskConfig = {
  // used to display custom fields in the task drawer
  // will appear between the "Action" and "Notes" fields

  // the keys will be nested by double underscores
  // job__title__program_id = job.title.program_id

  // to display only on a specific task type, pass `forTypes`: ['edit_task']
  // if blank, will display on all task types

  customFields: {
    job__title__program_id: {
      label: 'Program ID',
      cols: 7
    },
    job__title__broadcast_length: {
      label: 'Broadcast Length',
      cols: 5
      // forTypes: ['edit_task']
    },
    job__title__piece_id: {
      label: 'Piece ID',
      cols: 7
    },
    job__version__piece_number: {
      label: 'Piece Number',
      cols: 5
    }
  }
};

export default taskConfig;
